// extracted by mini-css-extract-plugin
export default {"section":"ClearApplication_section__uR6lZ","button":"ClearApplication_button__Kk5Qy"};